import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { Chip } from '#src/atoms/ui/Chip/index.tsx';
import { CardSetLabel } from '#src/components/collections/CardSetLabel/index.tsx';

import type { CardSetChip_cardSet } from './__generated__/index.graphql.ts';

type Props = {
  cardSet: CardSetChip_cardSet;
};

export const CardSetChip = ({ cardSet }: Props) => {
  return (
    <Chip size="small" color="transparent">
      <CardSetLabel cardSet={cardSet} />
    </Chip>
  );
};

CardSetChip.fragments = {
  cardSet: gql`
    fragment CardSetChip_cardSet on CardSet {
      slug
      ...CardSetLabel_cardSet
    }
    ${CardSetLabel.fragments.cardSet}
  ` as TypedDocumentNode<CardSetChip_cardSet>,
};
